module.exports = __webpack_public_path__ + "static/roy-6a3e4cf8edbe5fcffe4370ae4ec67903.jpg";